import React from 'react';

export default props => (
  <svg
    {...props}
    viewBox="0 0 150 150"
    style={{
      enableBackground: 'new 0 0 150 150',
    }}
  >
    {props.children}
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m149.7 99.8-74.6-43L.3 99.9l74.6 43 74.8-43.1Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.96 6.96"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M149.6 106.6 75.2 63.7.2 107l74.5 42.9 74.9-43.2Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M63 102.4C27.5 98 8.4 83.6 16.3 67.6A34 34 0 0 1 30 54.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m59.9 100.8 4.2 1.5-5 1.4m43.1-2.6s25.2-7.4 33.1-21.5c6.5-11.5 1.6-23-12.3-32"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m39.8 53.4 4.9-.7-.8-3.9s-1-1.1-.9-3c.6-4.5 4.6-8.3 10.6-10.8s14-3.8 22.5-3.4c8.6.4 16 2.5 21.1 5.6 5.2 3.1 8.1 7.3 7.6 11.8-.2 1.4-1.2 2.9-3 4.3a26.8 26.8 0 0 1-7 4.1 49 49 0 0 1-12 3.2l.6 5.3 5.6 6.8c5.2-1 8-2.2 12.1-4 8-3.8 13.5-9.3 14.2-15.6.7-5.8 0-10.2-1.7-13.5a16 16 0 0 0-8.3-7.2c-3.6-1.6-8-2.4-13-3-4.5-.5-9.5-.7-14.7-1H76l-3.5-.2c-4.5-.2-8.7-.4-12.7-.4-5 0-9.6.3-13.6 1.5s-7.3 3.1-9.8 6.3c-2.6 3.2-5 8.2-4.3 11.7.4 2.3.4 5.3 1.3 7.3l6.3-1.2Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M44 48.9a8.7 8.7 0 0 1-1-5c.5-4.5 4.5-8.3 10.5-10.9 6-2.6 14-4 22.5-3.6 8.6.4 16.2 2.6 21.5 5.7 5.2 3 8.3 7.2 7.8 11.7-.5 4.4-4.5 8.2-10.5 10.8A45.2 45.2 0 0 1 83 60.7l5.9 6.9c4.7-1 9-2.3 12.8-4 8-3.8 13.5-9.2 14.2-15.6.8-6.3-3.3-12.3-10.4-16.7-7-4.5-17.3-7.5-28.8-8a66.3 66.3 0 0 0-30.3 5.2c-8 3.8-13.5 9.3-14.3 15.6a13 13 0 0 0 1 6.5c3.6-.7 7.2-1.5 10.8-1.7Z"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m89 72.7-.1-5.1" />
    <path
      fill="#FAF5EF"
      d="M109 19.6c-13.8-8.8-41-11.1-60.6-5.3-2.3.7-4.3 1.4-6.2 2.2l.8 4.7c1.7-.7 3.5-1.3 5.5-1.9 19.6-5.8 46.8-3.5 60.6 5.3l-.2-5Z"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M123.3 39c-1.9-4-5.2-7.6-9.9-10.8" />
    <path
      fill="#fff"
      d="M73.9 113.7a.3.3 0 0 1-.3-.2v-1a11 11 0 0 0-.8-3.4c-.4-1-1-2-2-3.3a45 45 0 0 0-1-1.3l-.6-.7-.1-.1v-.3c.3-.8.8-1.6 1.2-2.3.9-1.6 1.8-3.2 2-5l.3-.1H77s.2 0 .2.2c.3 2 1.2 3.8 2.1 5.7l.8 1.5v.3l-.5.5c-1 1.2-2 2.5-2.8 4a10.5 10.5 0 0 0-1.3 4.8v.4c0 .2-.2.3-.3.3h-.4a.2.2 0 0 1-.2-.2c0 .1-.1.2-.3.2H74Zm.6-11.6c-.5 0-1 .3-1 .8-.1.3 0 .6.1.8.2.3.4.4.8.5l.1.3.2-.3c.5-.1.7-.4.8-.7v-.6a1 1 0 0 0-1-.8Z"
    />
    <path d="M77 96.2c.3 2.6 1.7 5 2.8 7.3l-.4.6a25 25 0 0 0-2.9 4c-.7 1.2-1 2.5-1.2 4l-.1 1.2v.2h-.4v-9c.5-.2.8-.4 1-1v-.7c-.2-.6-.6-1-1.3-1a1.3 1.3 0 0 0-1 2c.1.4.4.5.8.7v9h-.4v-1c-.2-1.2-.4-2.3-.9-3.4a15 15 0 0 0-2-3.5l-1.6-2-.1-.1c1-2.3 3-4.7 3.3-7.3H77m0-.5h-4.4c-.2 0-.4.2-.5.4-.2 1.7-1.1 3.3-2 4.8-.5.8-1 1.6-1.3 2.4v.5l.2.2a28.8 28.8 0 0 0 1.6 2c1 1.2 1.5 2.2 2 3.2.4 1 .6 2.1.7 3.3v.7l.1.3c0 .3.2.5.5.5h1.3c.2 0 .4-.2.4-.4v-.2l.1-.4v-.9c.2-1.4.6-2.7 1.3-3.9.7-1.4 1.7-2.7 2.7-3.8l.4-.5c.2-.2.2-.4.2-.6l-.8-1.5c-.9-1.9-1.8-3.7-2-5.7-.1-.2-.3-.4-.6-.4Zm-2.5 8.3c-.4-.1-.5-.2-.7-.4a.8.8 0 0 1 .6-1.3c.5 0 .8.2 1 .6l-.1.5c-.1.3-.3.5-.7.6Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M68.7 47.3v-.1Zm1.7 2.1-.2-.1c-.6-.4-1-.8-1.2-1.2-.2-.2-.3-.5-.3-.8V47l-.2-40.3c0 .9.6 1.7 1.7 2.4 2.3 1.3 6 1.3 8.4-.1 1.1-.7 1.7-1.6 1.7-2.5l.1 16.9v3l.1 16.4v4.3l-.3 1c-.2.3-.6.7-1.1 1l-.3.2a9.2 9.2 0 0 1-8.4.1Zm-1.7-2.1V47v.2Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M70.2 9c-1.2-.6-1.7-1.4-1.8-2.3 0-.9.6-1.8 1.8-2.4l1.4-.7c1.6-.5 3.5-.5 5.1-.1.7.1 1.3.3 1.8.7 1.2.6 1.8 1.5 1.8 2.4 0 .9-.6 1.7-1.7 2.4a9.2 9.2 0 0 1-8.4.1Zm1 78c-.9-.6-1.4-1.2-1.4-2l-1.1-37.7c0 .3.1.6.3.8.2.4.6.8 1.2 1.2l.2.1c2.3 1.3 6 1.3 8.4 0l.2-.2c.5-.4 1-.8 1.2-1.2l.3-.9v-.2.2l-.7 37.6c0 .8-.5 1.6-1.5 2.1a7.8 7.8 0 0 1-7 .1Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M72.6 7c-.4-.2-.8-.6-.8-1V2.8c0-3.4 5.1-3.4 5.1 0v3.1c-.2 1.7-3 1.8-4.3 1.1Zm2.2 89.8c-.8 0-1.7 0-2-.3h-.2c-1.8-3.4-2.5-6-2.7-9.8l-.1-1.6c0 .7.5 1.3 1.5 1.9 1 .5 2.2.8 3.5.8 1.3 0 2.6-.3 3.6-.8.9-.6 1.3-1.2 1.4-2v1.7c-.3 3.8-1 6.4-2.8 9.8h-.1c-.4.2-1.3.3-2 .3Zm5-12Z"
    />
    <path fill="#FAF5EF" d="M76.4 78.8v-5.6c-19.6-2-30.5-8-38.8-16.3l.3 6.2c8.4 8.4 16.7 13 38.5 15.7Z" />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m55.1 112.3 25.3 14.6-7.6 4.4-25.3-14.6 7.6-4.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M47.2 110.6c3.6 3.4 12.4 9.5 19 6.7 7.6-3.3-9.2-6.8-5.6 2.3.8 2 3 3 5.1 3.2 3.3.1 5.7.6 6.5 2.5 1.1 2.6 4 6.8 5.4 8.6"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m96.6 109-13.3 7.7 6.8 4 13.4-7.8-6.9-4Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m125.8 98.3-18 10.7m-85.2-6.4 19.2 10.6"
    />
  </svg>
);
